export default "__VITE_ASSET__Bu5fMc_X__"